export enum ReportType {
  ECP = 'ECP',
  Parent = 'PARENT',
}
